export default __webpack_public_path__ + "static/media/django.0779fca2.svg";